import { NgModule } from '@angular/core';
import { LogoIconComponent } from './logo-icon.component';

@NgModule({
    declarations: [LogoIconComponent],
    imports: [],
    exports: [LogoIconComponent],
})
export class LogoIconModule {}
